<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
     <app-select-form-field
        formControlName="ownerId"
        [label]="'problemRecord.fields.ownerId.label' | translate"
        [placeholder]="'placeholders.please_select'"
        [clearable]="true"
        [searchable]="true"
        [items]="ownerUsers"
        [bindValue]="'id'"
        [bindLabel]="'fullName'"
        [viewMode]="viewMode"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'ownerUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'ownerUsers', $event.page, $event.take)"
        (onSelectEvent)="changeTicketOwner($event)"
    ></app-select-form-field>
  </div>

</div>
